import React from 'react';
import styles from "../../styles/components/offeringBanner.module.scss";
import endpoints from '../../utility/endpoints'

export default function index(props) {
  //console.log(props, "framaework page image")

  const { field_background_image , field_hedaing, field_details,field_background_mobile } = props.data

  return (
    <div className={`${styles.frameworkbannerWrapper} container-fluid`}>
      <div className={`${styles.row} row`}>
      <div className="col-12">
      <div className={styles.imaging}>
          <img className={styles.image} src={ field_background_image} alt={field_background_image} />
          <img className={styles.imageMobile} src={field_background_mobile} alt="abc" />
          
        </div>
        <div className={styles.content}>
       
          <div className={`${styles.container} container py-4`}>
            <p className={styles.frameworkbannerHead}>{field_hedaing}</p>
            <div
              className={styles.frameworkbannerText}
              dangerouslySetInnerHTML={{
                __html: field_details
              }}
            >
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
